import { useEffect, useRef } from "react";
import * as Scrivito from "scrivito";
import { useNavigation } from "^/Context/NavigationContext";
import { sanitizeHtml } from "^/utils/sanitizeHtml";

const PageNavigationItem = ({ child }) => (
  <>
    <i className={`las la-${child.get("navigationIcon") || "university"}`}></i>
    <h6 className="page-navigation-item-title">
      {child.get("shortTitle") || child.get("title")}
    </h6>
    <div className="page-navigation-item-description">
      {sanitizeHtml(
        child.get("shortDescription") || child.get("description")
      ) || ""}
    </div>
  </>
);

function PageNavigation() {
  const rootRef = useRef(null);
  const { open, activeItem, activeMainItem, closeNavigation, setActiveItem } =
    useNavigation();

  useEffect(() => {
    if (!open) return;

    const handleOutsideClick = (event) => {
      if (!rootRef.current) return;
      if (rootRef.current.contains(event.target)) return;
      closeNavigation();
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [closeNavigation, open]);

  if (!open) return null;

  return (
    <div ref={rootRef} className="page-navigation d-flex align-items-stretch">
      <div className="page-navigation-side-bar">
        <Scrivito.ChildListTag
          parent={activeMainItem}
          renderChild={(child) => {
            if (child.get("hideInNavigation") === "yes") return null;
            return (
              <li
                className={
                  activeItem?.id() === child.id() ? "--active" : "--inactive"
                }
              >
                <a
                  href={Scrivito.urlFor(child)}
                  onClick={(event) => {
                    event.preventDefault();
                    setActiveItem(child);
                  }}
                >
                  {child.get("title")}
                </a>
              </li>
            );
          }}
        />
      </div>
      <div className="page-navigation-pages">
        <Scrivito.ChildListTag
          parent={activeItem}
          tag="div"
          renderChild={(child) => {
            if (child.get("hideInNavigation") === "yes") return null;
            return (
              <Scrivito.LinkTag
                to={child.objClass() === "Redirect" ? child.get("link") : child}
                className="col-12 col-lg-6 col-xl-4 page-navigation-item"
                onClick={() => {
                  closeNavigation();
                }}
              >
                <PageNavigationItem child={child} />
              </Scrivito.LinkTag>
            );
          }}
        />
      </div>
    </div>
  );
}

export default Scrivito.connect(PageNavigation);
